(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["spada-made-to-measure"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const styleId = 'spada-mtm-shopify-form-style';
    const styleText = `
      :host {
        display: block !important;
        width: 100% !important;
      }

      [data-testid="form"] {
        display: grid !important;
        grid-template-columns: repeat(var(--mtm-form-columns, 2), minmax(0, 1fr)) !important;
        column-gap: var(--mtm-form-gap, 18px) !important;
        row-gap: 16px !important;
        width: 100% !important;
        max-width: none !important;
      }

      [data-testid="form"] > * {
        min-width: 0;
      }

      [data-testid="form"] > div:has([data-testid="field-email"]),
      [data-testid="form"] > div:has([data-testid="field-phone_number"]),
      [data-testid="date-birthday"],
      [data-testid="btn-form-submit"],
      [data-testid="form"] > div:has(shop-lead-capture) {
        grid-column: 1 / -1;
      }

      [data-testid="field-first_name"],
      [data-testid="field-last_name"],
      [data-testid="field-email"],
      [data-testid="field-phone_number"],
      [data-testid="date-birthday"] input,
      [aria-label^="Country code"] {
        box-sizing: border-box !important;
        min-height: 58px !important;
        border: 0 !important;
        border-radius: var(--mtm-form-radius, 0px) !important;
        background: transparent !important;
        box-shadow: inset 0 -1px 0 rgba(21, 27, 39, .28) !important;
      }

      [data-testid="field-first_name"]:focus,
      [data-testid="field-last_name"]:focus,
      [data-testid="field-email"]:focus,
      [data-testid="field-phone_number"]:focus,
      [data-testid="date-birthday"] input:focus,
      [aria-label^="Country code"]:focus-visible {
        outline: 0 !important;
        box-shadow: inset 0 -2px 0 var(--mtm-accent, #9a7655) !important;
      }

      [data-testid="date-birthday"] {
        margin-top: 8px !important;
      }

      [data-testid="btn-form-submit"] {
        box-sizing: border-box !important;
        min-height: 58px !important;
        margin-top: 8px !important;
        border: 1px solid var(--mtm-ink, #151b27) !important;
        border-radius: 0 !important;
        background: var(--mtm-ink, #151b27) !important;
        color: #ffffff !important;
        font-size: 12px !important;
        font-weight: 600 !important;
        letter-spacing: .16em !important;
        text-transform: uppercase !important;
        transition: background-color .2s ease, color .2s ease !important;
      }

      [data-testid="btn-form-submit"]:hover {
        background: transparent !important;
        color: var(--mtm-ink, #151b27) !important;
      }

      @media (max-width: 620px) {
        [data-testid="form"] {
          grid-template-columns: minmax(0, 1fr) !important;
          row-gap: 12px !important;
        }

        [data-testid="form"] > * {
          grid-column: 1 !important;
        }
      }

      @media (prefers-reduced-motion: reduce) {
        [data-testid="btn-form-submit"] {
          transition: none !important;
        }
      }
    `;

    const enhance = (host) => {
      if (!host.shadowRoot || host.shadowRoot.getElementById(styleId)) return;
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = styleText;
      host.shadowRoot.appendChild(style);
    };

    const enhanceAll = () => {
      document.querySelectorAll('.spada-mtm__form shopify-forms-embed').forEach(enhance);
    };

    const observe = () => {
      enhanceAll();
      document.querySelectorAll('.spada-mtm__form').forEach((container) => {
        if (container.dataset.spadaMtmObserved === 'true') return;
        container.dataset.spadaMtmObserved = 'true';
        new MutationObserver(enhanceAll).observe(container, { childList: true, subtree: true });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observe, { once: true });
    } else {
      observe();
    }

    document.addEventListener('shopify:section:load', observe);
  })();

  } catch(e) { console.error(e); }
})();
})();
